const weaponProficiencies = [

    {
        "name": "Axe",
        "specialization": "When attacking with an axe, if your wound attempt fails, you may ignore it and attempt to wound the selected hit location again. Limit, once per attack.",
        "mastery": "When an Axe Master wounds a monster with an axe at a location with a persistent injury, that wound becomes a critical wound. All survivors gain Axe Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Bow",
        "specialization": "When attacking with a bow, you may reroll any misses once. Limit, once per attack.",
        "mastery": "If you are a Bow Master, all bows in your gear grid gain Deadly 2. In addition, ignore cumbersome on all bows. All survivors gain Bow Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Cleaver",
        "specialization": "You can use Cleaver Proficiency while Frenzy. When attacking while with a cleaver, ignore one wound reaction during that attack.",
        "mastery": "At the end of your attack with a cleaver, suffer the Frenzy brain trauma. When attacking while with a cleaver, if you draw a Trap, discard five other drawn Monster Hit Location Card to cancel the trap and shuffle it back into the deck.",
        "notes": null,
        "expansion": "Killennium Butcher"
    },
    {
        "name": "Club",
        "specialization": "When attacking with a club, on a Perfect hit, double your wound attempt total on the first selected hit location. Limit, once per attack.",
        "mastery": "When a Club Master attacks with a club, if a successful wound attempt total is greater than or equal to twice the monster's toughness, inflict an additional wound. All survivors gain Club Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Dagger",
        "specialization": "When attacking with a Dagger, if a wound attempt fails, after performing any reactions, you may discard another drawn hit location card to attempt to wound the failed hit location again. Limit, once per attack.",
        "mastery": "After a wounded hit location is discarded, a Dagger Master who is adjacent to the attacker and the wounded monster may spend 1 survival to re-draw the wounded hit location and attempt to wound with a dagger. "+
                   "Treat monster reactions on the re-drawn hit location card normally. All survivors gain Dagger Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Fan",
        "specialization": "At the start of your act, you may lose all deflect tokens. At the end of your act, if you are standing and have a fan in your gear grid, you may Deflect 1 for free.",
        "mastery": "While you have no deflect tokens, fans in your gear grid gain Sharp and Devastating 1. While you have deflect tokens, increase the range of your Perfect hits with fans by 2.",
        "notes": null,
        "expansion": "Sen"
    },
    {
        "name": "Fist & Tooth",
        "specialization": "You may stand (if knocked down) at the start of the monster's turn or the survivor's turn. Limit, once per round.",
        "mastery": "While a survivor is a Fist & Tooth Master, they gain +2 permanent accuracy and +2 permanent strength (they receive this bonus even when not attacking with Fist & Tooth). "+
                   "All survivors gain Fist & Tooth Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Grand Weapon",
        "specialization": "When attacking with a grand weapon, gain +1 accuracy. When attacking with a grand weapon during your act, if you critically wound, the monster is knocked down.",
        "mastery": "When a Grand Weapon Master perfectly hits with a grand weapon, cancel all reactions for that attack. All survivors gain Grand Weapon Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Katana",
        "specialization": "You may not select this as your weapon type. If you are blind and have 4+ levels of Katana proficiency, gain the following: On your first Perfect hit each attack with a Katana, do not draw a hit location. The monster suffers 1 wound.",
        "mastery": "When a survivor reaches Katana Mastery, they leave the settlement forever, heeding the call of the storm to hone their art. Before the master leaves, you may nominate a survivor. "+
                   "Set that survivor's weapon type to Katana and their weapon proficiency level to 1.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Katar",
        "specialization": "When attacking with a katar, cancel reactions on the first selected hit locations.",
        "mastery": "If you are a Katar Master, gain a +1 evasion token on a Perfect hit with a katar. When you are knocked down, remove all +1 evasion tokens. All survivors gain Katar Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Scythe",
        "specialization": "When you critically wound with a scythe, roll 1d10. On a 6+, shuffle the hit location deck (do not shuffle unresolved hit locations). Limit, once per round.",
        "mastery": "At the start of a Scythe Master's act, if they are insane, they gain +1 Activation, which they may only spend to activate scythes.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Shield",
        "specialization": "While a shield is in your gear grid, you are no longer knocked down after Collision with a monster. While a shield is in your gear grid, add 1 to all hit locations.",
        "mastery": "When a Shield Master is adjacent to a survivor that is targeted by a monster, they may swap spaces on the board with the survivor and become the target instead. The master must have a shield to perform this. "+
                   "All survivors gain Shield Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Spear",
        "specialization": "When attacking with a spear, if you draw a trap, roll 1d10. On a 7+, cancel the trap. Discard it, then reshuffle the hit location discard into the hit location deck and draw a new card. Limit, once per round.",
        "mastery": "Whenever a Spear Master hits a monster with a spear, they may spend 1 survival to gain the priority target token. If they made the hit from directly behind another survivor, that survivor gains the priority target token instead. "+
                   "All survivors gain Spear Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Sword",
        "specialization": "When attacking with a sword, after drawing hit locations, make a wound attempt and then select a hit location to resolve with that result. Limit, once per attack.",
        "mastery": "A Sword Master gains +1 accuracy, +1 strength, and +1 speed when attacking with a Sword. All survivors gain Sword Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Sword Willow",
        "specialization": "Swords in your gear grid gain Block 1 and the two-handed keyword. When you block or deflect a hit with a sword, gain +1 survival. Limit oncer per round.",
        "mastery": "After resolving a monster's AI Card Icon. If you ignored a hit with a block or deflect, you may spend 1 survival to activate a sword and attack. Limit once per round. The Novel Proficiency do NOT confer any benefits to other survivors in the settlement.",
        "notes": null,
        "expansion": "Willow"
    },
    {
        "name": "Twilight Sword",
        "specialization": "This sentient sword improves as it's used. Gain the effects as proficiency rank increases. 2 Ignore Cumbersome on Twilight Sword. 4 When attacking with the Twilight Sword, ignore slow and gain +2 speed. 6 Twilight Sword gains deadly",
        "mastery": "Any survivor who attains Twilight Sword Mastery leaves the settlement forever in pursuit of a higher purpose. Remove them from the settlement's population. You may place the master's Twilight Sword in another survivor's gear grid or archive it.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Whip",
        "specialization": "When you wound with a whip, instead of moving the top card of the AI deck into the wound stack, you may move the top card of the AI discard pile. Limit, once per attack.",
        "mastery": "Whip Masters gain +5 strength when attacking with a whip. All survivors gain Whip Specialization in addition to their other weapon proficiencies.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Lantern Armor",
        "specialization": "Add 1 to all hit locations. Ignore the accuracy and movement penalties from Lantern Armor.",
        "mastery": "All your attacks gain the club gear keyword. Increase the range of you Perfect hits by 1. Opposing Force: When a monster would collide with you, you may suffer damage equal to its movement and prevent it from moving any further. "+
                   "End the monster's movement adjacent to you and do not suffer collision.",
        "notes": "During the Aftermath, the survivor is eligible to gain a proficiency rank if they suffered damage during the showdown. "+
                 "In order to claim the benefits of Specialization and/or Mastery, the survivor must be wearing a full Lantern Armor set and claim its armor set bonus card.",
        "expansion": "Aya"
    },
];


export default weaponProficiencies;